import {
	Cardo,
	IBM_Plex_Sans,
	Inconsolata,
	Inter,
	Merriweather,
	Montserrat,
	Nunito,
	Roboto,
} from "next/font/google";

const roboto = Roboto({
	weight: ["300", "500", "700"],
	subsets: ["latin", "latin-ext"],
	preload: false,
});

const inter = Inter({
	weight: "variable",
	subsets: ["latin", "latin-ext"],
	preload: false,
});

const merriweather = Merriweather({
	weight: ["300", "400", "700"],
	subsets: ["latin", "latin-ext"],
	preload: false,
});

const montserrat = Montserrat({
	weight: ["300", "400", "700"],
	subsets: ["latin", "latin-ext"],
	preload: false,
});

const nunito = Nunito({
	weight: ["300", "400", "700"],
	subsets: ["latin", "latin-ext"],
	preload: false,
});

const inconsolata = Inconsolata({
	weight: "variable",
	subsets: ["latin", "latin-ext"],
	preload: false,
});

const ibmPlexSans = IBM_Plex_Sans({
	weight: "variable",
	subsets: ["latin", "latin-ext"],
	preload: false,
});

const cardo = Cardo({
	weight: ["400", "700"],
	subsets: ["latin", "latin-ext"],
	preload: false,
});

export const fontConfigs = {
	roboto: {
		name: "Roboto",
		font: roboto,
		url: "https://fonts.googleapis.com/css2?family=Roboto:wght@300;500;700&display=swap",
	},
	inter: {
		name: "Inter",
		font: inter,
		url: "https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap",
	},
	merriweather: {
		name: "Merriweather",
		font: merriweather,
		url: "https://fonts.googleapis.com/css2?family=Merriweather:wght@300;400;700&display=swap",
	},
	montserrat: {
		name: "Montserrat",
		font: montserrat,
		url: "https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;700&display=swap",
	},
	nunito: {
		name: "Nunito",
		font: nunito,
		url: "https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;700&display=swap",
	},
	inconsolata: {
		name: "Inconsolata",
		font: inconsolata,
		url: "https://fonts.googleapis.com/css2?family=Inconsolata:wght@200..900&display=swap",
	},
	ibmPlexSans: {
		name: "IBM Plex Sans",
		font: ibmPlexSans,
		url: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,100..700;1,100..700&display=swap",
	},
	cardo: {
		name: "Cardo",
		font: cardo,
		url: "https://fonts.googleapis.com/css2?family=Cardo:wght@400;700&display=swap",
	},
} as const;

// Helper to get all font entries for iteration
export const getFontEntries = () => {
	return Object.entries(fontConfigs) as Array<
		[keyof typeof fontConfigs, (typeof fontConfigs)[keyof typeof fontConfigs]]
	>;
};
